import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';
import About from '@/components/About';
import Services from '@/components/Services';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';
import Portfolio from '@/components/Portfolio';
import SEOHead from '@/components/SEOHead';
import { useTranslation } from 'react-i18next';
import { structuredDataGenerator } from '@/utils/structuredData';
import { getDomainUtils } from '@/utils/domainUtils';

const Index = () => {
    const { i18n } = useTranslation();
    const currentLang = i18n.language;
    const { getAlternateLanguages, getCanonicalUrl, getCurrentUrl, getImageUrl } = getDomainUtils();
    
    const structuredData = structuredDataGenerator.generateContextualSchema('person', null, currentLang);
    
    const alternateLanguages = getAlternateLanguages();

    return (
    <div className="min-h-screen">
        <SEOHead
            title={currentLang === 'fr' 
                ? 'Moudondi Godfried - Développeur Frontend' 
                : 'Moudondi Godfried - Frontend Developer'
            }
            description={currentLang === 'fr' 
                ? 'Développeur front-end spécialisé dans les expériences web modernes, React, TypeScript et le design responsive. Créateur d\'expériences numériques fluides.' 
                : 'Frontend developer specializing in modern web experiences, React, TypeScript, and responsive design. Creating smooth digital experiences.'
            }
            keywords={currentLang === 'fr' 
                ? 'développeur web, développeur frontend, React, TypeScript, JavaScript, design responsive, UI/UX, Moudondi Godfried, développeur France' 
                : 'web developer, frontend developer, React, TypeScript, JavaScript, responsive design, UI/UX, Moudondi Godfried, developer France'
            }
            canonical={getCanonicalUrl()}
            ogUrl={getCurrentUrl()}
            ogImage={getImageUrl('/assets/images/og-image.jpg')}
            ogType="profile"
            lang={currentLang}
            alternateLanguages={alternateLanguages}
            structuredData={structuredData}
        />
        <Navbar />
        <Hero />
        <About />
        <Services />
        <Portfolio />
        <Contact />
        <Footer />
    </div>
    );
};

export default Index;
